<template>
  <el-input-number
    v-bind="$attrs"
    v-on="$listeners"
    :min="$attrs.min || 0"
    :max="$attrs.max || 999999999.99"
    :size="$attrs.size || 'small'"
    :controls="$attrs.controls || false"
    :class="align_class"
    :style="{ width: w + 'px'}"
  ></el-input-number>
</template>
<script>
/**
 * created by yuanzishu 2019/07/23
 */
const ALIGN_CLASS_MAP = {
  left: "input-number__left",
  right: "input-number__right"
};
export default {
  name: "sd-input-number",
  props: {
    align: {
      type: String,
      default: "center"
    },
    w: {
      type: [String, Number],
      default: 150
    }
  },
  computed: {
    align_class() {
      return ALIGN_CLASS_MAP[this.align] || "";
    }
  }
};
</script>

<style lang="scss">
.input-number__left .el-input .el-input__inner {
  text-align: left;
}
.input-number__right .el-input .el-input__inner {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// SdInputNumber.vue?37ca7a71